import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UtilsService } from "../../auth/service/utils.service";
import { locale as invoiceIt } from "./i18n/invoice.lang-it";
import invoiceSettingsLinks from "./invoice.settings-list";
import { RouterModule } from "@angular/router";
import invoiceRoutes from "./invoice.routes";
import invoiceMenu from "./invoice.menu";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { TranslateModule } from "@ngx-translate/core";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgbAlertModule, NgbDropdownModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { ExtendedModule } from "@angular/flex-layout";
import { CoreCommonModule } from "../../../@core/common.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { InvoiceToCreateComponent } from "./pages/invoice/to-create/invoice-to-create.component";
import { LayoutModule } from "../../layout/layout.module";
import { InvoiceRowTypeComponent } from "./pages/invoice-row-type/invoice-row-type.component";
import { InvoiceDocumentTypeComponent } from "./pages/invoice-document-type/invoice-document-type.component";
import { InvoicePaymentTypeComponent } from "./pages/invoice-payment-type/invoice-payment-type.component";
import { InvoiceSendedComponent } from "./pages/invoice/sended/invoice-sended.component";
import { InvoiceGeneratedComponent } from "./pages/invoice/generated/invoice-generated.component";
import { InvoiceSetAsPayedComponent } from "./components/invoice-set-as-payed/invoice-set-as-payed.component";
import { InvoiceServicesComponent } from "./pages/invoice-services/invoice-services.component";
import { InvoiceModalDetailComponent } from "./components/invoice-modal-detail/invoice-modal-detail.component";
import { InvoiceCompletedComponent } from "./pages/invoice/completed/invoice-completed.component";
import { InvoiceArchivedComponent } from "./pages/invoice/archived/invoice-archived.component";
import { NgApexchartsModule } from "ng-apexcharts";
import InvoiceCreateComponent from "./pages/invoice-create/invoice-create.component";
import InvoiceEditComponent from "./pages/invoice-edit/invoice-edit.component";
import { InvoiceDocumentCodeComponent } from "./pages/invoice-document-code/invoice-document-code.component";
import { BreadcrumbModule } from "../../layout/components/content-header/breadcrumb/breadcrumb.module";
import { CreditNoteCreateComponent } from './pages/credit-note-create/credit-note-create.component';
import { InvoiceRowComponent } from './components/invoice-row/invoice-row.component';
import { CreditNoteRowComponent } from './components/credit-note-row/credit-note-row.component';
import { InvoiceFileAttachmentsComponent } from './components/invoice-file-attachments/invoice-file-attachments.component';
import { CreditNoteEditComponent } from './pages/credit-note-edit/credit-note-edit.component';

@NgModule({
  declarations: [
    InvoiceToCreateComponent,
    InvoiceRowTypeComponent,
    InvoiceDocumentTypeComponent,
    InvoiceDocumentCodeComponent,
    InvoicePaymentTypeComponent,
    InvoiceGeneratedComponent,
    InvoiceSendedComponent,
    InvoiceSetAsPayedComponent,
    InvoiceServicesComponent,
    InvoiceModalDetailComponent,
    InvoiceCompletedComponent,
    InvoiceArchivedComponent,
    InvoiceCreateComponent,
    InvoiceEditComponent,
    CreditNoteCreateComponent,
    InvoiceRowComponent,
    CreditNoteRowComponent,
    InvoiceFileAttachmentsComponent,
    CreditNoteEditComponent
  ],
  exports: [InvoiceToCreateComponent],
  imports: [
    RouterModule.forChild(invoiceRoutes),
    CommonModule,
    NgSelectModule,
    CoreCommonModule,
    ContentHeaderModule,
    TranslateModule,
    ExtendedModule,
    Ng2FlatpickrModule,
    NgxDatatableModule,
    NgbTooltipModule,
    LayoutModule,
    NgbDropdownModule,
    NgApexchartsModule,
    BreadcrumbModule,
    NgbAlertModule
  ]
})
export class InvoiceModule {
  constructor(private _utils: UtilsService) {
    this._utils.initModule("invoice", invoiceIt, invoiceMenu, invoiceSettingsLinks);
  }
}
